module.exports = __webpack_public_path__ + "static/media/Portrait-10063_original.83416011.jpg";